import { render, staticRenderFns } from "./FeatureCardPdf.vue?vue&type=template&id=31756f53&"
import script from "./FeatureCardPdf.vue?vue&type=script&lang=js&"
export * from "./FeatureCardPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports